import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, ArrowRight, Home } from 'lucide-react';

const AdminAccess = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 to-orange-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-2xl p-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-gradient-to-r from-red-600 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <Shield size={32} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Admin Access</h1>
          <p className="text-gray-600">Direct access to admin panel</p>
        </div>

        {/* Access Options */}
        <div className="space-y-4">
          {/* Direct Admin Access */}
          <Link
            to="/admin"
            className="flex items-center justify-between w-full p-4 bg-gradient-to-r from-red-600 to-orange-600 text-white rounded-lg hover:from-red-700 hover:to-orange-700 transition-all duration-200 transform hover:scale-105"
          >
            <div className="flex items-center space-x-3">
              <Shield size={24} />
              <div>
                <div className="font-semibold">Admin Dashboard</div>
                <div className="text-sm opacity-90">Full admin panel access</div>
              </div>
            </div>
            <ArrowRight size={20} />
          </Link>

          {/* Alternative Admin Access */}
          <Link
            to="/admin-access"
            className="flex items-center justify-between w-full p-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105"
          >
            <div className="flex items-center space-x-3">
              <Shield size={24} />
              <div>
                <div className="font-semibold">Alternative Access</div>
                <div className="text-sm opacity-90">Bypass authentication</div>
              </div>
            </div>
            <ArrowRight size={20} />
          </Link>

          {/* Back to Home */}
          <Link
            to="/"
            className="flex items-center justify-center w-full p-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            <Home size={20} className="mr-2" />
            Back to Home
          </Link>
        </div>

        {/* Info */}
        <div className="mt-6 p-4 bg-blue-50 rounded-lg">
          <p className="text-sm text-blue-800">
            <strong>Note:</strong> This is a direct access point to the admin panel. 
            No authentication required for development purposes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminAccess;
